import AdminUpdatePasein from "../../components/AdminFinanceRekapUserFee/FinanceRekapUserFeeUpdate";

export default function UpdatePasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminUpdatePasein/>
    </div>
  );
}
